import { createStyles, makeStyles } from '@material-ui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    field: {
      marginBottom: theme.spacing(2.5),
    },
  })
);

export default useStyles;
